import axios from '@/shared/utils/axios';
import { AiStoreFront } from '@/shared/types/ecommerceforall';

export async function getStoreFront() {
  const response = await axios.get<ListResponse<AiStoreFront>>('/app/ai-store-fronts/landing-page-data');
  return response.data;
}

export async function supportStoreFront(id: number) {
  const response = await axios.post(`/app/ai-store-fronts/support/` + id);
  return response.data;
}
